import PropTypes from 'prop-types';
import React from 'react';
import withState from 'recompose/withState';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import Icon, { GLYPHS } from '../../../../common/icon';
import { t } from '../../../../../modules/infra/i18n';

const enhance = compose(
  withState('expanded', 'setExpanded', false),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      if (nextProps.value && nextProps.value !== this.props.value && nextProps.expanded === false) {
        nextProps.setExpanded(true);
      }
    },
  })
);

const Notes = ({ onChange, value, expanded, setExpanded, title, disabled }) => (
  <div className="layout__item u-1/2-medium-and-up">
    <button
      className="c-btn c-btn--blank c-btn--link u-pl0 u-mt-"
      type="button"
      onClick={() => setExpanded(current => !current)}
      disabled={disabled}
    >
      <span className="u-mr--">{title || t('appointment:form.appointment_notes_title')}</span>
      <Icon glyph={expanded ? GLYPHS.remove : GLYPHS.plus} className="o-icon o-icon--small" />
    </button>
    <textarea
      className="c-textarea"
      placeholder={t('appointment:form.notes_placeholder')}
      onChange={e => onChange(e.target.value)}
      value={value}
      display-if={expanded}
      disabled={disabled}
    />
  </div>
);

Notes.propTypes = {
  value: PropTypes.string,
  expanded: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  setExpanded: PropTypes.func.isRequired,
  title: PropTypes.string,
  disabled: PropTypes.bool,
};

Notes.defaultProps = {
  value: '',
  expanded: false,
  title: undefined, // Will be handled in component
  disabled: false,
};

export default enhance(Notes);
